import { DetailPage } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function CodeSortiePoubellesFields({ item, set }) {
    const t = useTranslations()
    return <>
        <TextInput label={t("Code")} value={item.code} onChange={set('code')} required />
        <TextInput label={t("Description")} value={item.description} onChange={set('description')} required />
    </>
}

export function CodesSortiePoubellesList(props) {
    const t = useTranslations()
    return <ListPage model="codesSortiePoubelles" title={t("Codes Sortie Poubelles")} columns={{
        [t('Code')]: 'code',
        [t('Description')]: 'description',
    }} {...props} />
}

export function CodeSortiePoubellesDetail(props) {
    const t = useTranslations()
    return <DetailPage model="codesSortiePoubelles" title={t("Code Sortie Poubelles")} Fields={CodeSortiePoubellesFields} {...props}></DetailPage >
}
